// The weekly hat in the kit (PLAN-2026-10-30-the-weekly-hat §7): which teams
// wear which hat in the league on screen, handed down by the shell
// (`LeagueHatScope`), so every team mark and character draws it without a
// screen passing it along.

import { createContext, useContext, type ReactNode } from 'react';
import type { WeeklyHat } from '@fsp/domain';

interface Worn {
  hat: WeeklyHat;
  wearers: ReadonlySet<string>;
}

const HatContext = createContext<Worn | null>(null);

export function HatProvider({ worn, children }: { worn: Worn | null; children: ReactNode }) {
  return <HatContext.Provider value={worn}>{children}</HatContext.Provider>;
}

/** The hat a team wears this week in the league on screen, or null. */
export function useTeamHat(teamId: string | undefined): WeeklyHat | null {
  const worn = useContext(HatContext);
  return worn !== null && teamId !== undefined && worn.wearers.has(teamId) ? worn.hat : null;
}
